import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import '../../Styles/Payments/paySuccessStyle.css';

function PaySuccess() {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get("session_id");

    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/home');
        }, 3000); // 3 seconds

        return () => clearTimeout(timer); // cleanup
    }, [navigate]);

    return (
        <div className="paymentSuccessContainer">
            <h1>✅ Payment Successful</h1>
            <p>Thank you for your payment! Your session has been confirmed.</p>

            {sessionId && (
                <div style={{ marginTop: '1rem', fontSize: '0.9rem', color: '#666' }}>
                    <p><strong>Session ID:</strong> {sessionId}</p>
                </div>
            )}
        </div>
    )
}

export default PaySuccess;